import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Home from './components/Home';
import ImageToPdf from './components/ImageToPdf';
import IpLookup from './components/IpLookup';
import JsonFormatter from './components/JsonFormatter';
import XmlFormatter from './components/XmlFormatter';
import ImageConverter from './components/ImageConverter';
import FaviconGenerator from './components/FaviconGenerator';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
        <header className="app-header">
          <nav className="navbar">
            <div className="nav-brand">
              <Link to="/" className="brand-link">
                <h1>AI工具箱</h1>
              </Link>
            </div>
            <ul className="nav-menu">
              <li><Link to="/" className="nav-link">首页</Link></li>
              <li><Link to="/image-to-pdf" className="nav-link">图片转PDF</Link></li>
              <li><Link to="/ip-lookup" className="nav-link">IP查询</Link></li>
              <li><Link to="/json-formatter" className="nav-link">JSON格式化</Link></li>
              <li><Link to="/xml-formatter" className="nav-link">XML格式化</Link></li>
              <li><Link to="/image-converter" className="nav-link">图片转换</Link></li>
              <li><Link to="/favicon-maker" className="nav-link">Favicon制作</Link></li>
            </ul>
          </nav>
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/image-to-pdf" element={<ImageToPdf />} />
            <Route path="/ip-lookup" element={<IpLookup />} />
            <Route path="/json-formatter" element={<JsonFormatter />} />
            <Route path="/xml-formatter" element={<XmlFormatter />} />
            <Route path="/image-converter" element={<ImageConverter />} />
            <Route path="/favicon-maker" element={<FaviconGenerator />} />
          </Routes>
        </main>

        <footer className="app-footer">
           <p>&copy; 2025 AI工具箱. 所有工具免费使用.</p>
         </footer>
         </div>
       </Router>
     </HelmetProvider>
   );
 }

export default App;
